<template>
	<div class='nav_bar' id="mydiv">
		<h1 class='logo' :class="{'is-active':isActive}">
			<img src="../../assets/images/top_logo.png" alt="">
			<span v-if='!isActive'>采购EDI系统</span>
		</h1>
		<div class='open_aside'>
			<svg
				:class="{'is-active':isActive}"
				class="hamburger"
				viewBox="0 0 1024 1024"
				xmlns="http://www.w3.org/2000/svg"
				width="64"
				height="64"
				@click="toggleSideBar">
				<path
					d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"/>
			</svg>
		</div>
		<div class="navbar-custom-menu">
				<span class="query-title-span"><b>皮肤切换</b></span>
				<el-select v-model="colorCode" style="width: 50%"
						   placeholder="请选择" @change="changeColor(colorCode)">
					<el-option v-for="option in styleList" :label=option.lable :value=option.value
							   :key=option.value></el-option>
				</el-select>
		</div>
		<div class="navbar-custom-menu">
			<el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                      <i class='hidden-xs'>欢迎：{{ userAcc }}</i>
                  </span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item @click.native="toResetPwd">密码修改</el-dropdown-item>
					<el-dropdown-item @click.native="signOut">安全退出</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		<el-dialog title="密码重置" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
			<div class="dialog-overflow iot-form">
				<Form ref="pwdFrom" :model="pwdInfo" :rules="ruleValidate">
					<FormItem label="新密码" prop="userPassword">
						<Input v-model="pwdInfo.userPassword" type="password"></Input>
					</FormItem>
					<FormItem label="确认密码" prop="userPasswordCp">
						<Input v-model="pwdInfo.userPasswordCp" type="password"></Input>
					</FormItem>
					<FormItem class="iot-form-actions-div check-child-submit">
						<Button type="primary" class="iot-btn-submit info-color"
								v-loading.fullscreen.lock="fullscreenLoading" @click="submitPwdReset('pwdFrom')"><i
							class="fa fa-save"></i>&nbsp;&nbsp;提交
						</Button>
						<Button type="ghost" class="iot-btn-cancel mgn-lf-10" @click="cancelPwdReset"><i
							class="fa fa-close"></i>&nbsp;&nbsp;取消
						</Button>
					</FormItem>
				</Form>
			</div>
		</el-dialog>
		<el-dialog title="密码已过期,请修改密码" :visible.sync="dialogVisible2" width="600px" :close-on-click-modal="false" @close="signOut">
			<div class="dialog-overflow iot-form">
				<Form ref="pwdFrom" :model="pwdInfo" :rules="ruleValidate">
					<FormItem label="新密码" prop="userPassword">
						<Input v-model="pwdInfo.userPassword" type="password"></Input>
					</FormItem>
					<FormItem label="确认密码" prop="userPasswordCp">
						<Input v-model="pwdInfo.userPasswordCp" type="password"></Input>
					</FormItem>
					<FormItem class="iot-form-actions-div check-child-submit">
						<Button type="primary" class="iot-btn-submit info-color"
								v-loading.fullscreen.lock="fullscreenLoading" @click="submitPwdReset('pwdFrom')"><i
							class="fa fa-save"></i>&nbsp;&nbsp;提交
						</Button>
						<Button type="ghost" class="iot-btn-cancel mgn-lf-10" @click="signOut"><i
							class="fa fa-close"></i>&nbsp;&nbsp;取消
						</Button>
					</FormItem>
				</Form>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {mapActions} from "vuex";
import sdnJob from "../../utils/sdnJob";

export default {
	// ...mapActions("tab", ["reflush"]),
	name: "home",
	props: {
		isActive: {
			type: Boolean,
			default: false,
		},
		toggleSideBar: {
			type: Function,
			default: null
		}
	},
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.pwdInfo.userPassword) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			userAcc: '',
			pwdInfo: {},
			fullscreenLoading: false,
			dialogVisible: false,
			dialogVisible2:false,
			syscode:{},
			queryParam: {
				codeType: ''
			},
			ruleValidate: {
				userPassword: [
					{required: true, message: '请输入密码', trigger: 'blur'}
				],
				userPasswordCp: [
					{required: true, validator: validatePass, trigger: 'blur'}
				],
			},
			colorCode:'',
			styleList: [
				{
					lable: '芳草绿',
					value: '1'
				},
				{
					lable: '典雅蓝',
					value: '2'
				},
				{
					lable: '可爱粉',
					value: '3'
				}
			]
		};
	},
	mounted() {
		var _this = this;
		var currUser = JSON.parse(_this.$cookie.get(_this.$config.cookies.currUser));
		var skincolor = _this.$cookie.get(_this.$config.cookies.skinColor);
		if(skincolor == undefined) skincolor = "2";
		_this.changeColor(skincolor);
		this.userAcc = currUser.userName;
		//delete by duan 20211011 start
		// var deadDate = new Date(currUser.dateEnd);
		// console.log("----user:"+deadDate+"||"+ skincolor);
		// var today = new Date();

		//获取密码系数规则
		this.queryParam.codeType = "PWD_CONFIG";
		this.syscode = this.$sdnJob.getCodeByType(this, this.queryParam);
		// console.log(this.syscode);
		//delete by duan 20211011 start
		// if(deadDate < today) {
		// 	// this.$util.error2("密码过期请修改密码..");
		// 	this.dialogVisible2=true;
		// }
		//delete by duan 20211011 end
	},
	methods: {
		changeColor(num){
			document.getElementById('app').className='theme'+num;
			var mydiv = document.getElementById("myhead");
			var mydiv1 = document.getElementById("mytab");
			if(num == 1) {
				mydiv.style.backgroundColor = "yellowgreen";
				mydiv1.style.backgroundColor = "yellowgreen";
			}else if(num == 2) {
				mydiv.style.backgroundColor = "#337ab7";
				mydiv1.style.backgroundColor = "#337ab7";
			}else if(num == 3) {
				mydiv.style.backgroundColor = "#FFC0CB";
				mydiv1.style.backgroundColor = "#FFC0CB";
			}
			var _this = this;
			_this.$cookie.set("skinColor", num);
		},
		signOut() {
			this.$router.push({
				name: "login"
			});
		},
		toResetPwd() {
			this.dialogVisible = true;
		},
		// 提交密码重置
		submitPwdReset(formName) {
			var _this = this;
			_this.fullscreenLoading = true;
			//Alpha
			let flgAlpha = false;
			//Number
			let flgNumber = false;
			//BigChat
			let flgBigChat = false;
			//Length
			var len = 6;
			//Special
			let flgSpecial = false;
			this.syscode.forEach(item => {
				if (item.code == "PWD_ALPHA" && item.codeNm == "TRUE") flgAlpha = true;
				if (item.code == "PWD_NUMBER" && item.codeNm == "TRUE") flgNumber = true;
				if (item.code == "PWD_BIG" && item.codeNm == "TRUE") flgBigChat = true;
				if (item.code == "PWD_SPECIAL" && item.codeNm == "TRUE") flgSpecial = true;
				if (item.code == "PWD_LENGTH") len = parseInt(item.codeNm);
			})
			var password = _this.pwdInfo.userPassword;
			var password2 = _this.pwdInfo.userPasswordCp;
			var type1 = /(?=.*?[A-Z])/;//至少1个大写字母
			var type2 = /(?=.*?[0-9])/;//至少1个数字
			var type3 = /(?=.*?[a-z])/;//至少1个小写字母
			var type4 = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s])/; //特殊
			if (password == '' || password == null || password == undefined) {
				_this.$util.error("密码不能为空!");
				_this.fullscreenLoading = false;
				return;
			}
			if(password.length < len){
				_this.$util.error("密码长度至少需要"+len+"位。");
				_this.fullscreenLoading = false;
				return;
			}
			if (flgSpecial) {
				//复合特殊
				if (!type4.test(password)) {
					_this.$util.error("复合密码需要有大小写字母数字和特殊符号!");
					_this.fullscreenLoading = false;
					return;
				}
			}
			if(flgNumber){
				if (!type2.test(password)) {
					_this.$util.error("密码需要有1个数字!");
					_this.fullscreenLoading = false;
					return;
				}
			}
			if(flgBigChat){
				if (!type1.test(password)) {
					_this.$util.error("密码需要有1个大写字母!");
					_this.fullscreenLoading = false;
					return;
				}
			}
			if(flgAlpha){
				if (!type3.test(password)) {
					_this.$util.error("密码需要有1个小写字母!");
					_this.fullscreenLoading = false;
					return;
				}
			}
			if (!(password == password2)) {
				_this.$util.error("两次输入密码不一致!");
				_this.fullscreenLoading = false;
				return;
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					var currUser = JSON.parse(_this.$cookie.get(_this.$config.cookies.currUser));
					currUser.userPassword = _this.pwdInfo.userPassword;
					_this.$httpUtil.ajaxPatch(_this, _this.$api.user.list, currUser, function (response) {
						_this.$util.success('修改成功');
						_this.dialogVisible = false;
						_this.dialogVisible2 = false;
						_this.fullscreenLoading = false;
					});
				}
			});
		},
		// 取消
		cancelPwdReset() {
			this.pwdInfo = {};
			this.dialogVisible = false;
		},
	}
};
</script>

<style lang='scss' scoped>

.nav_bar {
	width: 100%;
	background-color: #337ab7;

	.logo {
		float: left;
		height: 50px;
		text-align: center;
		width: 200px;
		// background-color: #27404c;
		line-height: 50px;

		img {
			vertical-align: middle;
			margin-top: -6px;
		}

		&.is-active {
			width: 64px;

			img {
				vertical-align: middle;
				margin-top: -6px;
			}
		}

		span {
			font-weight: 400;
			font-size: 22px;
			color: #fff;
			margin-left: 6px;
		}
	}

}


.open_aside {
	float: left;
	width: 36px;
	text-align: center;
	line-height: 48px;
	border-radius: 4px;
	padding-top: 8px;

	&:hover {
		background-color: #367fa9
	}

	.hamburger {
		display: inline-block;
		cursor: pointer;
		width: 24px;
		height: 24px;
		/*vertical-align: middle;*/
		fill: #fff;
	}

	.hamburger.is-active {
		transform: rotate(180deg);
	}
}

.navbar-custom-menu {
	float: right;
	cursor: pointer;
	margin-right: 50px;

	.user-image {
		float: left;
		width: 25px;
		height: 25px;
		border-radius: 50%;
		margin-right: 10px;
		margin-top: 12px;
	}

	.hidden-xs {
		color: #fff;
	}
}


</style>



// WEBPACK FOOTER //
// src/components/HeaderBar/index.vue